export default __webpack_public_path__ + "static/media/logo_nav.c73cbe2e.svg";